// Helper function to get the items or operator path for a given field path
// e.g., "items[0]" -> "items", "items[0]" -> "operator"
// e.g., "items[0].items[1]" -> "items[0].items", "items[0].items[1]" -> "items[0].operator"
function getGroupPath(fieldPath: string, pathType: 'items' | 'operator') {
  return fieldPath.includes('.') ? fieldPath.replace(/\.items\[\d+\]$/, `.${pathType}`) : pathType;
}
export function getGroupOperatorPath(fieldPath: string) {
  return getGroupPath(fieldPath, 'operator');
}
export function getGroupItemsPath(fieldPath: string) {
  return getGroupPath(fieldPath, 'items');
}

// Helper function to extract items path and index from a fieldPath
// e.g., "items[0].items[1]" -> { itemsPath: "items[0].items", index: 1 }
// e.g., "items[0]" -> { itemsPath: "items", index: 0 }
export function parseFieldPath(fieldPath: string) {
  const indexMatch = fieldPath.match(/\[(\d+)\]$/);
  if (!indexMatch) {
    return { itemsPath: null, basePath: null, index: null };
  }
  const index = parseInt(indexMatch[1], 10);
  const itemsPath = fieldPath.replace(/\[\d+\]$/, '');
  return { itemsPath, index };
}

// Numbers a filter by its place in the tree for its accessible name
// e.g., "items[0]" -> "1", "items[0].items[1]" -> "1.2", "items[0].operator" -> "1", "operator" -> ""
export function getFilterPosition(fieldPath: string) {
  return Array.from(fieldPath.matchAll(/\[(\d+)\]/g), (match) => Number(match[1]) + 1).join('.');
}
